import React, { useState, useEffect, useRef } from "react"
import { ScreenLayout } from "../components/ScreenLayout"
import { API } from "../utils/API"
import { Card, Table, Modal, Button, message, Form, DatePicker, InputNumber, Input, Space } from "antd"
import { SearchOutlined } from "@ant-design/icons"
import NewProductModal from "../components/NewProductModal"
const { Column } = Table
const Products = () => {
	const [products, setProducts] = useState([])
	const [newProductVisible, setNewProductVisible] = useState(false)
	const [isEditing, setIsEditing] = useState(false)
	const [selectedProduct, setSelectedProduct] = useState()
	const searchInput = useRef(null)
	useEffect(() => {
		API.getProducts().then((res) => setProducts(res.data))
	}, [])
	useEffect(() => {
		if (!newProductVisible) API.getProducts().then((res) => setProducts(res.data))
	}, [newProductVisible])
	const deleteProduct = (id) => {
		Modal.confirm({
			title: "Confirm delete",
			content: "Do you want to delete this product?",
			okText: "Yes",
			cancelText: "No",
			onOk: () => {
				API.deleteProduct(id).then(() => {
					API.getProducts().then((res) => setProducts(res.data))
				})
			},
		})
	}
	const editProduct = (product) => {
		console.log(product)
		setIsEditing(true)
		setSelectedProduct(product)
		setNewProductVisible(true)
	}
	const clearSelectedProduct = () => {
		console.log("TESTING")
		setSelectedProduct(null)
	}
	useEffect(() => {
		if (selectedProduct) setNewProductVisible(true)
	}, [selectedProduct])
	return (
		<ScreenLayout>
			<Card
				title="Products"
				style={{ margin: "20px auto", maxWidth: 1400 }}
				extra={
					<Button
						type="primary"
						onClick={() => {
							setIsEditing(false)
							setNewProductVisible(true)
						}}
					>
						New Product
					</Button>
				}
			>
				<Table
					dataSource={products}
					// components={{
					//     body: {
					//         row: EditableRow,
					//         cell: EditableCell,
					//     },
					// }}
					rowClassName={() => "editable-row"}
				>
					<Column
						title="Name"
						dataIndex="name"
						key="name"
						//filters={filters}
						//onFilter={(value, record) => record.product?.indexOf(value) === 0}
						sorter={(a, b) => a.name.localeCompare(b.name)}
						filterDropdown={({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
							<div style={{ padding: 8 }}>
								<Input
									ref={searchInput}
									placeholder={`Search Product Name`}
									value={selectedKeys[0]}
									onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
									onPressEnter={() => confirm()}
									style={{ marginBottom: 8, display: "block" }}
								/>
								<Space>
									<Button
										onClick={() => {
											clearFilters()
											confirm()
										}}
										size="small"
										style={{ width: 90 }}
									>
										Reset
									</Button>
									<Button
										type="primary"
										onClick={() => confirm()}
										icon={<SearchOutlined />}
										size="small"
										style={{ width: 90 }}
									>
										Search
									</Button>
								</Space>
							</div>
						)}
						filterIcon={(filtered) => (
							<SearchOutlined
								style={{
									color: filtered ? "#1890ff" : undefined,
								}}
							/>
						)}
						onFilter={(value, record) => (record.name ? record.name.toString().includes(value) : "")}
						onFilterDropdownVisibleChange={(visible) => {
							if (visible) {
								setTimeout(() => searchInput.current?.select(), 100)
							}
						}}
					/>
					<Column
						title="Description"
						dataIndex="description"
						key="description"
						//filters={filters}
						//onFilter={(value, record) => record.product?.indexOf(value) === 0}
						sorter={(a, b) => a.description.localeCompare(b.description)}
					/>
					<Column
						title="File Name"
						dataIndex="filename"
						key="fileName"
						//filters={filters}
						//onFilter={(value, record) => record.product?.indexOf(value) === 0}
						sorter={(a, b) => a.filename.localeCompare(b.filename)}
						filterDropdown={({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
							<div style={{ padding: 8 }}>
								<Input
									ref={searchInput}
									placeholder={`Search File Name`}
									value={selectedKeys[0]}
									onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
									onPressEnter={() => confirm()}
									style={{ marginBottom: 8, display: "block" }}
								/>
								<Space>
									<Button
										onClick={() => {
											clearFilters()
											confirm()
										}}
										size="small"
										style={{ width: 90 }}
									>
										Reset
									</Button>
									<Button
										type="primary"
										onClick={() => confirm()}
										icon={<SearchOutlined />}
										size="small"
										style={{ width: 90 }}
									>
										Search
									</Button>
								</Space>
							</div>
						)}
						filterIcon={(filtered) => (
							<SearchOutlined
								style={{
									color: filtered ? "#1890ff" : undefined,
								}}
							/>
						)}
						onFilter={(value, record) => (record.filename ? record.filename.toString().includes(value) : "")}
						onFilterDropdownVisibleChange={(visible) => {
							if (visible) {
								setTimeout(() => searchInput.current?.select(), 100)
							}
						}}
					/>
					<Column
						title="File Hash SHA-256"
						dataIndex="file_hash"
						key="file_hash"
						sorter={(a, b) => a.file_hash.localeCompare(b.file_hash)}
					/>
					<Column
						title=""
						dataIndex="id"
						key="id"
						align="right"
						render={(record) => (
							<>
								<Button type="info" onClick={() => editProduct(record)}>
									Edit
								</Button>
								<Button type="danger" style={{ marginLeft: 10 }} onClick={() => deleteProduct(record)}>
									Delete
								</Button>
							</>
						)}
					/>
				</Table>

				<NewProductModal
					product={selectedProduct}
					newOrderVisible={newProductVisible}
					setNewProductVisible={setNewProductVisible}
					setOrders={setProducts}
					clearSelectedProduct={clearSelectedProduct}
					isEditing={isEditing}
				/>
			</Card>
		</ScreenLayout>
	)
}

export default Products
